import { gql } from 'apollo-boost';
export default gql`
  mutation clearPresence { clearPresence }
`;
